/* istanbul ignore file */

import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { Filter } from 'src/components/organisms/Filter/components/Filter';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { actions } from 'src/redux/filter/slice';

const mapStateToProps = ({ filter, products }: ReduxApplicationState) => {
  return {
    isModalOpen: filter.isModalOpen,
    error: products.error,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    closeFilterModal: () => dispatch(actions.closeModal()),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const FilterContainer = connector(Filter);
